import React, { useState } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import secureLocalStorage from "react-secure-storage"
import avatar1 from "../../assets/images/users/avatar-1.jpg"
import Configs from "../../config"

const WelcomeComp = () => {
  // const [profileModal, setProfileModal] = useState(false);
  // let { name, email, photoPhoto } = secureLocalStorage.getItem("authUser")
  // const profileImage = photoPhoto ? `${process.env.REACT_APP_IMAGE_PATH}/${photoPhoto}` : avatar1
  const user = secureLocalStorage?.getItem("admin_user")

  let profileImage = avatar1

  return (
    <React.Fragment>
      <Card className="overflow-hidden profile_nav text-white shadow-lg">
        <div className="border-bottom border-info mb-3">
          <Row>
            <Col xs="12">
              <div className="text-white px-3 pt-3">
                <h5 className="text-white">Welcome Back !</h5>
                <p>J. Kyle Cleaning Services </p>
              </div>
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row>
            <Col sm="12" className="d-flex gap-4 align-items-center">
              <div className="avatar-md profile-user-wid mb-2">
                <img
                  src={
                    user?.profilePicture
                      ? `${Configs.imageUrl}${user?.profilePicture}`
                      : profileImage
                  }
                  alt=""
                  style={{
                    height: 70,
                    width: 70,
                    objectFit: "cover",
                    objectPosition: "top",
                  }}
                  className="img-thumbnail rounded-circle"
                />
              </div>
              <div className=" mb-1">
                <h4 className="mb-1">{user?.name}</h4>
                <h6 className="text-white mb-0 " title={user?.email}>
                  {user?.email}
                </h6>
                <div>
                  {/* <button 
                    className="btn btn-primary  btn-sm"
                  >
                    View Profile <i className="mdi mdi-arrow-right ms-1"></i>
                  </button> */}
                </div>
              </div>
            </Col>
            {/* <Col sm="6">
              <div className="pt-4">
                <div className="mt-4">
                  <button
                    onClick={() => setProfileModal(true)}
                    className="btn btn-primary  btn-sm"
                  >
                    View Profile <i className="mdi mdi-arrow-right ms-1"></i>
                  </button>
                </div>
              </div>
            </Col> */}
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}
export default WelcomeComp

// <Card className="overflow-hidden bg-darkblue p-3 mb-3 shadow-lg">
//   <div className="d-flex justify-content-between text-white h-100">
//     <div className="align-self-center d-flex justify-content-start ps-3">
//       <div className="avatar-md profile-user-wid mb-1 me-2 d-flex align-items-center">
//         <img
//           src={avatar1}
//           alt=""
//           width={80}
//           height={80}
//           className="img-thumbnail rounded-circle"
//         />
//       </div>
//     </div>
//     <div>
//       <div className="d-flex flex-column">
//         <h5 className="fw-medium">Welcome Back !</h5>
//         <h3 className=" text-truncate mb-0 fw-bold text-end">
//           J. Kyle
//         </h3>
//       </div>
//     </div>
//   </div>
// </Card>
